import React from 'react'

import FakeMenu from './FakeMenu'
import TopFilter from '../../ClientChatPanel/TopFilter'
import SimpleInbox from './SimpleInbox'
import MobileSelectViewModal from '../../../../components/molecules/ChatModals/MobileSelectViewModal'
import MobileSelectInboxModal from '../../../../components/molecules/ChatModals/MobileSelectInboxModal'

import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { selectBaseInbox, loadBaseInboxes } from '../../../../slices/baseInbox'
import { selectViews, fetchViews } from '../../../../slices/views'
import { selectConvo, setInbox } from '../../../../slices/convo'
import { useAgent } from '../../../../providers/AgentProvider'
import useStyles from './styles'

interface MobileInboxSelectProps {
  noShadow?: boolean
}

const MobileInboxSelect: React.FC<MobileInboxSelectProps> = ({ noShadow }) => {
  const dispatch = useAppDispatch()
  const { loaded, inboxes } = useAppSelector(selectBaseInbox)
  const { loaded: viewsLoaded, loading: viewsLoading } =
    useAppSelector(selectViews)
  const { topFilter, inbox } = useAppSelector(selectConvo)

  const { subscribeToInboxes } = useAgent()

  const [changingView, setChangingView] = React.useState(false)
  const [changingInbox, setChangingInbox] = React.useState(false)

  React.useEffect(() => {
    if (!loaded) {
      dispatch(loadBaseInboxes())
    }
  }, [loaded, dispatch])

  // Subscribe to inboxes after loading
  React.useEffect(() => {
    if (loaded) {
      const ids = inboxes.map(inbox => inbox.id)

      const timer = setInterval(() => {
        const success = subscribeToInboxes(ids)

        if (success) {
          clearInterval(timer)
        }
      }, 1000)

      return () => {
        clearInterval(timer)
      }
    }
  }, [loaded, inboxes, subscribeToInboxes])

  React.useEffect(() => {
    if (!viewsLoaded && !viewsLoading) {
      dispatch(fetchViews())
    }
  }, [viewsLoaded, viewsLoading, dispatch])

  React.useEffect(() => {
    if (loaded && inbox === null) {
      if (inboxes[0]) {
        dispatch(setInbox(inboxes[0].id))
      }
    }
  }, [loaded, inbox, inboxes, dispatch])

  const classes = useStyles({ noShadow })

  const handleOpenViews = React.useCallback(() => {
    setChangingView(true)
  }, [])

  const handleCloseViews = React.useCallback(() => {
    setChangingView(false)
  }, [])

  const handleOpenInboxes = React.useCallback(() => {
    setChangingInbox(true)
  }, [])

  const handleCloseInboxes = React.useCallback(() => {
    setChangingInbox(false)
  }, [])

  return (
    <>
      <div className={classes.root}>
        <div className={classes.container}>
          <div className={classes.row}>
            <div className='title'>Views</div>

            <FakeMenu onClick={handleOpenViews}>
              <TopFilter
                hideSelect
                text={topFilter}
                className={classes.topFilter}
              />
            </FakeMenu>
          </div>

          <div className={classes.row}>
            <div className='title'>Inboxes</div>

            <FakeMenu onClick={handleOpenInboxes}>
              <SimpleInbox />
            </FakeMenu>
          </div>
        </div>
      </div>

      {changingView && <MobileSelectViewModal onClose={handleCloseViews} />}

      {changingInbox && <MobileSelectInboxModal onClose={handleCloseInboxes} />}
    </>
  )
}

export default MobileInboxSelect
